import React from "react";

import * as Styled from "./Feedback.styled";
import { FeedbackProps } from "./Feedback.types";

export const Feedback: React.FC<FeedbackProps> = props => {
  return (
    <Styled.Root>
      <Styled.StarsDateContainer>
        <Styled.Stars>
          {Array.from({ length: 5 }).map((_, index) => (
            <Styled.Star key={index} />
          ))}
        </Styled.Stars>
        <span>{props.date}</span>
      </Styled.StarsDateContainer>
      <Styled.Title>{props.title}</Styled.Title>
      <Styled.Feedback>{props.feedback}</Styled.Feedback>
      <Styled.Authour>{props.author}</Styled.Authour>
    </Styled.Root>
  );
};
